module.exports = {
  message: {
    'hello': 'hello'
  },
  btn: {
    text: 'button'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js